module.exports = __webpack_public_path__ + "img/pexels-felix-haumann-3735930.f1e90eee.jpg";